import { render, staticRenderFns } from "./preview01.vue?vue&type=template&id=234c6c9c&scoped=true"
import script from "./preview01.vue?vue&type=script&lang=js"
export * from "./preview01.vue?vue&type=script&lang=js"
import style0 from "./preview01.vue?vue&type=style&index=0&id=234c6c9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234c6c9c",
  null
  
)

export default component.exports